<template>
	<div>
		<v-data-table
				:headers="headers"
				:page.sync="page"
				:items="items"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				class="updateTable"
				:items-per-page="getItemsPerPage"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
				fixed-header
		>
			<template v-slot:header="{ props: { headers } }">
				<thead>
				<tr>
					<th
							v-for="(item, index) in headers"
							:class="[{'filter-active': filterClasses[item.value]},
                                {'dense': item.dense}]"
							:key="index"
							class=""
							:id="'container-'+item.value"
					>
						<div class="filterIcons">
							<sort-btn
									v-if="item.sortable"
									:sortDesc="sortDesc"
									:sortBy="sortBy"
									:data-sort="item.value"
									@updateToggleOrder="toggleOrder"
							></sort-btn>
							<span
									class="headText wh_w"
									:class="{
								'headText_sorted': getSortColor(sortBy, item.value),
								 'center': item.value === 'optional'}">{{ item.text }}
							</span>
						</div>
					</th>
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<component
							:is="keyTable === 'fuel' ? 'TableFuelTr' : 'TableClientsTr'"
							:item="item"
							:key="getUniqKey(idx)"
							:idx="idx"
							:checkClasses="checkClasses"
							@updateEdit="onEdit"
							@updateRemoveItem="onRemoveItem"
							@updateCommentsPopup="onCommentsPopup"
					></component>
				</template>
				<tr class="tableBottom">
					<td :key="i" v-for="i in headers.length">
						<div v-if="i === 1">n: <span>{{ items.length }}</span></div>
						<div v-if="i === 16">Σ: $<span>{{ getTotal }}</span></div>
					</td>
				</tr>
				</tbody>
			</template>
		</v-data-table>
		<pagination
				v-if="items.length"
				:length="items.length"
				:pageCount="pageCount"
				:itemsPerPage="itemsPerPage"
				:page="page"
				:isRefreshPage="isRefreshPage"
				:pages="pages"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>
	</div>
</template>

<script>
// components
import TableFuelTr from "@/components/Accounting/Fuel/UpdateTable/TableTr/TableFuelTr";
import TableClientsTr from "@/components/Accounting/Fuel/UpdateTable/TableTr/TableClientsTr";
import SortBtn from "@/shared/SortBtn/SortBtn";
// shared
import Pagination from "@/shared/Pagination/Pagination";
// constants
import defaultHeader from "@/components/Accounting/Fuel/UpdateTable/constants";
// helpers
import { formatCurrency } from "@/helper";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "UpdateTable",
	components: {
		TableFuelTr,
		TableClientsTr,
		Pagination,
		SortBtn,
	},
	props: {
		items: Array,
		keyTable: String,
		keyHeader: String
	},
	computed: {
		headers() {
			return defaultHeader[this.keyHeader];
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		getTotal() {
			const total = this.items.reduce((acc, item) => acc += +item.qty, 0);
			return formatCurrency(total);
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
	},
	data() {
		return {
			pages: [ 20, 50, 100, 200, 500 ],
			itemsPerPage: 20,
			page: 1,
			pageCount: 0,
			sortBy: "",
			sortDesc: true,
			filters: {},
			checkClasses: {},
			filterPreloader: false,
			isRefreshPage: '',
		};
	},
	methods: {
		onEdit(id) {
			this.$emit('updateEdit', id);
		},
		getUniqKey(idx) {
			return getUniqId() + idx;
		},
		onCommentsPopup(values) {
			this.$emit('updateCommentsPopup', values);
		},
		onRemoveItem(id) {
			this.$emit('updateRemoveItem', id);
		},
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		toggleOrder(val) {
			this.sortBy = val.slice(7);
			this.sortDesc = !this.sortDesc;
		}
	}
};
</script>

<style scoped lang="scss">
@import "updateTable";
</style>

<style lang="scss">
.updateTable {
  .v-data-table__wrapper {
    max-height: calc(100vh - (164px + 55px));
  }
}
</style>
